/**
 * Query used to fetch all users associated with the given business entity (vendor) id.
 * Below are the list of services that it talks to:
 * AWSSCMUserManagement (UMS)
 */
import { gql } from '@apollo/client';
import KatalLogger from '@katal/logger';
import { omit } from 'lodash';

export const getUsersForBusinessEntityIdQuery = gql`
  query getUsersForBusinessEntityId($businessEntityId: String!, $continuationToken: String, $maxResults: Int!) {
    getUsersForBusinessEntityId(
      businessEntityId: $businessEntityId
      continuationToken: $continuationToken
      maxResults: $maxResults
    ) {
      users {
        userId
        givenName
        familyName
        username
        userType
        vendorIds
        emails {
          value
          isPrimary
        }
        onboardStatus
        applications
      }
      continuationToken
    }
  }
`;

export interface GetUsersForBusinessEntityIdResult {
  users?: RawUser[];
  continuationToken?: string;
}

/**
 * Vendor user
 */
export interface User {
  userId: string;
  givenName: string;
  familyName: string;
  username: string;
  vendorIds: string[];
  emails: Email[];
}

/**
 * Raw user get from GraphQL query
 */
export interface RawUser extends User {
  userType: string | null;
  onboardStatus: OnboardStatus;
  applications: string[];
}

export interface Email {
  value?: string;
  isPrimary?: boolean;
}

export type OnboardStatus = 'DISABLED' | 'CREATED' | null;

export const EXTERNAL_USER_TYPE = 'VENDOR_EMPLOYEE';